import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

import { Item } from './Item'
import { Line } from './Line'
import { BloodPressureStatus } from './BloodPressureStatus'

const styles = {
  characteristic: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  line: {
    marginBottom: 24,
  },
}

const type = 'bloodPressure'

export const BloodPressure = ({ syst, diast }) => (
  <>
    <div style={styles.characteristic}>
      <Item label="Sistólica" text={syst} width={50} />
      <Item label="Diastólica" text={diast} width={56} />
      <BloodPressureStatus syst={syst} diast={diast} type={type} />
    </div>
    <Line lineColor={colors.softGray} style={styles.line} />
  </>
)

BloodPressure.propTypes = {
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
}
